const preOrder = [
   {
      name: "Batman Lego",
      link: "/collections/lego-batman-legacy-of-the-dark-knight",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/Banner_pre_order_Batman.webp?v=1769650463",
   },
   {
      name: "Nickelodeon Tennis",
      link: "/collections/nickelodeon-extreme-tennis-next",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/Nickelodeon_Extreme_Tennis_with_nsw.webp?v=1776142782",
   },
   {
      name: "Assassins Creed Black Flag Resynced",
      link: "/collections/assassins-creed-black-flag-resynced",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/April_Assassins_Creed_Black_Flag_Resynced.webp?v=1777339826",
   },
   {
      name: "Beast of Reincarnation",
      link: "/products/pre-order-playstation-5-beast-of-reincarnation-asi",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/April_Beast_of_Reincarnation.webp?v=1777515099",
   },
   {
      name: "UFC 6",
      link: "/products/pre-order-playstation-5-ufc-6-asi-1",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/UFC6.webp?v=1775613378",
   },
   {
      name: "Invincible",
      link: "/products/pre-order-playstation-5-invincible-vs-us",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/April_INVINCIBLE.webp?v=1777357653",
   },
   {
      name: "Destroy All Humans!",
      link: "/products/pre-order-nintendo-switch-2-destroy-all-humans-game-key-card-eur",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/Destroy_All_Humans.webp?v=1776401223",
   },
   {
      name: "Darksiders Warmastered Edition",
      link: "/products/pre-order-playstation-5-darksiders-warmastered-edition-eur",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/Darksiders_Warmastered_Pre_order.webp?v=1776395398",
   },
   {
      name: "Bus Bound Deluxe Edition",
      link: "/products/pre-order-playstation-5-bus-bound-deluxe-edition-eur",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/Bus_Bound.webp?v=1776393816",
   },
   {
      name: "This is Fine",
      link: "/collections/this-is-fine",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/Banner_This_is_fine.webp?v=1769589541",
   },
   {
      name: "Aphelion Pioneer Edition",
      link: "/products/pre-order-playstation-5-aphelion-pioneer-edition-eur",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/Aphelion.webp?v=1776392323",
   },
   {
      name: "Formula Legends - Legacy Edition",
      link: "/collections/formula-legends-legacy-edition",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/Formula_Legends.webp?v=1776391952",
   },
   {
      name: "King of Tokyo Limited Edition",
      link: "/collections/king-of-tokyo-limited-edition",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/Web_King_of_Tokyo_Pre_order.webp?v=1776393187",
   },
   {
      name: "MAMIYA - A Shared Illusion of the World's End",
      link: "/products/pre-order-nintendo-switch-mamiya-a-shared-illusion-of-the-worlds-end-jpn",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/Mamiya_Pre_Order.webp?v=1776212086",
   },
   {
      name: "Bluey's Quest for the Gold Pen",
      link: "/collections/blueys-quest-for-the-gold-pen",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/April_Bluey_s_Quest_Pre_order.webp?v=1776061920",
   },
   {
      name: "Cult of the Lamb Definitive Edition",
      link: "/collections/cult-of-the-lamb-definitive-edition",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/Cult_of_the_lamb_pre_order_png.webp?v=1776058614",
   },
   {
      name: "Granblue Fantasy Endless Ragnarok",
      link: "/collections/granblue-fantasy-endless-ragnarok",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/Granblue_Fantasy_Pre_order_2.webp?v=1776058384",
   },
   {
      name: "Mouse P.I. for Hire",
      link: "/collections/mouse-p-i-for-hire",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/WEB2.webp?v=1775796223",
   },
   {
      name: "Star Wars Zero Company",
      link: "https://gamextreme.ph/products/pre-order-playstation-5-star-wars-zero-company-asi",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/Star_wars_zero_pre_order.webp?v=1775520324",
   },
   {
      name: "Story of Seasons: Grand Bazaar - Standard Edition",
      link: "/products/pre-order-playstation-5-story-of-seasons-grand-bazaar-standard-edition-us",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/Story_of_Seasons_pre_order.webp?v=1775019954",
   },
   {
      name: "Gunvolt Chronicles: Luminous Avenger IX",
      link: "/collections/gunvolt-chronicles-luminous-avenger-ix",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/Gunvolt.webp?v=1774834103",
   },
   {
      name: "Five Nights at Freddy's: Secret of the Mimic",
      link: "/products/pre-order-playstation-5-five-nights-at-freddys-secret-of-the-mimic-asi",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/Five_nights_at_aguilar_secret_of_the_mimic.webp?v=1774321753",
   },
   {
      name: "Yoshi and the Mysterious Book",
      link: "/products/pre-order-nintendo-switch-2-yoshi-and-the-mysterious-book-asi",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/Yoshi.webp?v=1774244473",
   },
   {
      name: "Indiana Jones and the Great Circle™",
      link: "/products/pre-order-nintendo-switch-2-indiana-jones-and-the-great-circle%E2%84%A2-asi",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/IndianaJones-PreOrder_1.webp?v=1772519933",
   },
   {
      name: "Tales of Arise: Beyond the Dawn Edition",
      link: "/products/pre-order-nintendo-switch-2-tales-of-arise-beyond-the-dawn-edition-asi",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/Tales_of_AriseWEB.png?v=1771567528",
   },
   {
      name: "Rayman",
      link: "/collections/rayman",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/Rayman_WEB.png?v=1771567529",
   },
   {
      name: "The Disney Afternoon Collection",
      link: "/collections/the-disney-afternoon-collection",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/DISNEY.png?v=1771380596",
   },
   {
      name: "Wandering Sword",
      link: "/products/pre-order-playstation-5-wandering-sword-asi",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/Banner_Wandering_Sword.webp?v=1769590390",
   },
   {
      name: "Until Then",
      link: "/collections/until-then",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/Banner_Until_Then.webp?v=1769590386",
   },
   {
      name: "The Relic: First Guardian Special Edition",
      link: "/products/pre-order-playstation-5-the-relic-first-guardian-special-edition-eur",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/Banner_The_Relic.webp?v=1769590405",
   },
   {
      name: "007 First Light",
      link: "/collections/007-first-light",
      image: "https://cdn.shopify.com/s/files/1/0442/2749/4055/files/Banner_ebf1b4dd-a347-4a6c-a1cb-8edfde281d65.webp?v=1769578621",
   },
];


const preOrderHtml = `
   <div class="pre-order-header">
      <img class="header-img"
         src="https://cdn.shopify.com/s/files/1/0442/2749/4055/files/PREORDER.webp?v=1770190968"
      />
   </div>

   <div class="banner-links">


   ${preOrder
      .map(
         ({ name, link, image }) => `
      <a
         href="${link}"
      >
         <img
            src="${image}"
            alt="${name}"
         />
      </a>
         `,
      )
      .join("")}

   </div>
`;

function initPreOrder() {
    const preOrderRoot = document.getElementById("pre-order-root");
    
    if (!preOrderRoot) return;
    preOrderRoot.innerHTML = preOrderHtml;
}

// const style = document.createElement("style");
// style.textContent = `
//   .pre-order-root {
//      width: 90vw;
//      margin-inline: auto;
//   }

//   .banner-links {
//      display: grid;
//      grid-template-columns: repeat(2, 1fr);
//      gap: 30px;
//   }
// `;


document.addEventListener("DOMContentLoaded", initPreOrder)
document.addEventListener("shopify:section:load", initPreOrder)
document.head.appendChild(style);